// extracted by mini-css-extract-plugin
export var alternate = "image-and-text-v2-module--alternate--94d5e";
export var content = "image-and-text-v2-module--content--57ac5";
export var contentBlock = "image-and-text-v2-module--contentBlock--c76a1";
export var image = "image-and-text-v2-module--image--a04b8";
export var reverse = "image-and-text-v2-module--reverse--47c27";
export var root = "image-and-text-v2-module--root--4c58e";
export var rtl = "image-and-text-v2-module--rtl--2a8e2";
export var wrapper = "image-and-text-v2-module--wrapper--65813";